import { DataSheet, PaginatedDataSheets } from '@lune-fe/dapi-models'
import { TableNew } from '@lune-fe/lune-ui-lib'
import { RefObject } from 'react'

import { ImportsTableRow } from 'views/CalculateEmissions/index'

const ImportsTable = ({
    paginatedImports,
    loading,
    accountNamesMap,
    currentPage,
    pageHistoryRef,
    queryParams,
}: {
    paginatedImports?: PaginatedDataSheets
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
    loading: boolean
    accountNamesMap: Record<string, string>
}) => {
    return (
        <TableNew.TableContainer>
            <TableNew
                sx={{ minWidth: paginatedImports?.data.length ? '1200px' : 'auto' }}
                stickyHeader
                loading={!paginatedImports || loading}
                empty={!loading && !paginatedImports?.data.length}
                headerCells={
                    <>
                        <TableNew.TableCell colSize={2}>Type</TableNew.TableCell>
                        <TableNew.TableCell colSize={2}>Imported from</TableNew.TableCell>
                        <TableNew.TableCell colSize={2}>Uploaded</TableNew.TableCell>
                        <TableNew.TableCell colSize={2}>Client account</TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd>
                            Calculations
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd>
                            Errors
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd>
                            tCO₂e
                        </TableNew.TableCell>
                        <TableNew.TableCell colSize={1} alignEnd />
                    </>
                }
                bodyCells={
                    <>
                        {paginatedImports?.data.map((item: DataSheet, i: number) => (
                            <ImportsTableRow
                                key={i}
                                sheet={item}
                                accountNamesMap={accountNamesMap}
                                queryParams={queryParams}
                                currentPage={currentPage}
                                pageHistoryRef={pageHistoryRef}
                            />
                        ))}
                    </>
                }
            />
        </TableNew.TableContainer>
    )
}

export default ImportsTable
